import { configureStore } from '@reduxjs/toolkit';
import { user } from './user/slice';
import { configs } from './configs/slice';
import { loan } from './loan/slice';
import { plan } from './plan/slice';
import { requerimentos } from './requerimentos/slice';
import { tourBoasVindas } from './tourBoasVindas/slice';
import { persistUserMiddleware } from './middlewares/persistUserMiddleware';

const store = configureStore({
  reducer: {
    user,
    plan,
    loan,
    configs,
    requerimentos,
    tourBoasVindas,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(persistUserMiddleware.middleware),
});

export default store;
